import { ModelNodeType } from 'web';
import { PARAMETER_TRANSLATION_KEYS } from '@/language/node-parameters.keys';
import { ParameterTranslationConfig, SharedTranlsations } from './parameters.types';

export const PARAMETER_TRANSLATIONS_CONFIG: {
  custommodelV2: {
    [K in ModelNodeType]: {
      [k: string]: ParameterTranslationConfig;
    };
  };
  muxv2: {
    [k: string]: ParameterTranslationConfig;
  };
  masks: {
    [k: string]: ParameterTranslationConfig;
  };
  shared: {
    [k in SharedTranlsations]: ParameterTranslationConfig;
  };
} = {
  custommodelV2: {
    wildcard: {}, // No translation for wildcard nodes since it has dynamic parameters
    minimax_image01: {
      number_of_images: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.MINIMAX_IMAGE01.NUMBER_OF_IMAGES.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.MINIMAX_IMAGE01.NUMBER_OF_IMAGES.DESCRIPTION,
      },
      aspect_ratio: {
        titleKey: PARAMETER_TRANSLATION_KEYS.SHARED.ASPECT_RATIO.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.MINIMAX_IMAGE01.ASPECT_RATIO.DESCRIPTION,
      },
      prompt_optimizer: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.MINIMAX_IMAGE01.PROMPT_OPTIMIZER.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.MINIMAX_IMAGE01.PROMPT_OPTIMIZER.DESCRIPTION,
      },
    },
    reve: {
      aspect_ratio: {
        titleKey: PARAMETER_TRANSLATION_KEYS.SHARED.ASPECT_RATIO.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.REVE.ASPECT_RATIO.DESCRIPTION,
      },
    },
    imagen3: {
      aspect_ratio: {
        titleKey: PARAMETER_TRANSLATION_KEYS.SHARED.ASPECT_RATIO.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.IMAGEN3.ASPECT_RATIO.DESCRIPTION,
      },
      safety_filter_level: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.IMAGEN3.SAFETY_FILTER_LEVEL.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.IMAGEN3.SAFETY_FILTER_LEVEL.DESCRIPTION,
      },
    },
    flux_canny_pro: {
      seed: {
        titleKey: PARAMETER_TRANSLATION_KEYS.SHARED.SEED.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.SEED.DESCRIPTION,
      },
      steps: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.STEPS.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.STEPS.DESCRIPTION,
      },
      prompt_upsampling: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.PROMPT_UPSAMPLING.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.PROMPT_UPSAMPLING.DESCRIPTION,
      },
      guidance: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.GUIDANCE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.GUIDANCE.DESCRIPTION,
      },
      safety_tolerance: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.SAFETY_TOLERANCE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.SAFETY_TOLERANCE.DESCRIPTION,
      },
      output_format: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.OUTPUT_FORMAT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.OUTPUT_FORMAT.DESCRIPTION,
      },
    },
    flux_depth_pro: {
      seed: {
        titleKey: PARAMETER_TRANSLATION_KEYS.SHARED.SEED.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.SEED.DESCRIPTION,
      },
      steps: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.STEPS.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.STEPS.DESCRIPTION,
      },
      prompt_upsampling: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.PROMPT_UPSAMPLING.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.PROMPT_UPSAMPLING.DESCRIPTION,
      },
      guidance: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.GUIDANCE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.GUIDANCE.DESCRIPTION,
      },
      safety_tolerance: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.SAFETY_TOLERANCE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.SAFETY_TOLERANCE.DESCRIPTION,
      },
      output_format: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.OUTPUT_FORMAT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.OUTPUT_FORMAT.DESCRIPTION,
      },
    },
    flux_redux_dev: {
      aspect_ratio: {
        titleKey: PARAMETER_TRANSLATION_KEYS.SHARED.ASPECT_RATIO.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.ASPECT_RATIO.DESCRIPTION,
      },
      num_outputs: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.NUM_OUTPUTS.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.NUM_OUTPUTS.DESCRIPTION,
      },
      num_inference_steps: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.NUM_INFERENCE_STEPS.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.NUM_INFERENCE_STEPS.DESCRIPTION,
      },
      guidance: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.GUIDANCE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.GUIDANCE.DESCRIPTION,
      },
      seed: {
        titleKey: PARAMETER_TRANSLATION_KEYS.SHARED.SEED.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.SEED.DESCRIPTION,
      },
      output_format: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.OUTPUT_FORMAT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.OUTPUT_FORMAT.DESCRIPTION,
      },
      output_quality: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.OUTPUT_QUALITY.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.OUTPUT_QUALITY.DESCRIPTION,
      },
      disable_safety_checker: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.DISABLE_SAFETY_CHECKER.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.DISABLE_SAFETY_CHECKER.DESCRIPTION,
      },
      megapixels: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.MEGAPIXELS.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.MEGAPIXELS.DESCRIPTION,
      },
    },
    wan_video: {
      aspect_ratio: {
        titleKey: PARAMETER_TRANSLATION_KEYS.SHARED.ASPECT_RATIO.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.ASPECT_RATIO.DESCRIPTION,
      },
      frame_num: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.FRAME_NUM.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.FRAME_NUM.DESCRIPTION,
      },
      resolution: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.RESOLUTION.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.RESOLUTION.DESCRIPTION,
      },
      sample_steps: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.SAMPLE_STEPS.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.SAMPLE_STEPS.DESCRIPTION,
      },
      sample_guide_scale: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.SAMPLE_GUIDE_SCALE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.SAMPLE_GUIDE_SCALE.DESCRIPTION,
      },
      sample_shift: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.SAMPLE_SHIFT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.SAMPLE_SHIFT.DESCRIPTION,
      },
    },
    br_bgreplace: {
      fast: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.BR_BGREPLACE.FAST.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.BR_BGREPLACE.FAST.DESCRIPTION,
      },
      refine_prompt: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.BR_BGREPLACE.REFINE_PROMPT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.BR_BGREPLACE.REFINE_PROMPT.DESCRIPTION,
      },
      original_quality: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.BR_BGREPLACE.ORIGINAL_QUALITY.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.BR_BGREPLACE.ORIGINAL_QUALITY.DESCRIPTION,
      },
    },
    luma_photon: {
      aspect_ratio: {
        titleKey: PARAMETER_TRANSLATION_KEYS.SHARED.ASPECT_RATIO.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.LUMA_PHOTON.ASPECT_RATIO.DESCRIPTION,
      },
      image_reference_weight: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.LUMA_PHOTON.IMAGE_REFERENCE_WEIGHT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.LUMA_PHOTON.IMAGE_REFERENCE_WEIGHT.DESCRIPTION,
      },
      style_reference_weight: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.LUMA_PHOTON.STYLE_REFERENCE_WEIGHT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.LUMA_PHOTON.STYLE_REFERENCE_WEIGHT.DESCRIPTION,
      },
    },
    flux_fast: {
      aspect_ratio: {
        titleKey: PARAMETER_TRANSLATION_KEYS.SHARED.ASPECT_RATIO.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_FAST.ASPECT_RATIO.DESCRIPTION,
      },
      guidance: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_FAST.GUIDANCE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_FAST.GUIDANCE.DESCRIPTION,
      },
      output_format: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_FAST.OUTPUT_FORMAT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_FAST.OUTPUT_FORMAT.DESCRIPTION,
      },
      output_quality: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_FAST.OUTPUT_QUALITY.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_FAST.OUTPUT_QUALITY.DESCRIPTION,
      },
    },
    gpt_image1: {
      model: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.GPT_IMAGE_1.MODEL.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.GPT_IMAGE_1.MODEL.DESCRIPTION,
      },
      size: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.GPT_IMAGE_1.SIZE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.GPT_IMAGE_1.SIZE.DESCRIPTION,
      },
      quality: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.GPT_IMAGE_1.QUALITY.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.GPT_IMAGE_1.QUALITY.DESCRIPTION,
      },
      background: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.GPT_IMAGE_1.BACKGROUND.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.GPT_IMAGE_1.BACKGROUND.DESCRIPTION,
      },
    },
    sd_sketch: {
      control_strength: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.SD_SKETCH.CONTROL_STRENGTH.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.SD_SKETCH.CONTROL_STRENGTH.DESCRIPTION,
      },
      control_type: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.SD_SKETCH.CONTROL_TYPE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.SD_SKETCH.CONTROL_TYPE.DESCRIPTION,
      },
    },
    minimax_video_director: {
      prompt_optimizer: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.MINIMAX_VIDEO_DIRECTOR.PROMPT_OPTIMIZER.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.MINIMAX_VIDEO_DIRECTOR.PROMPT_OPTIMIZER.DESCRIPTION,
      },
    },
    hunyuan3_d: {
      steps: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.STEPS.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.STEPS.DESCRIPTION,
      },
      guidance_scale: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.GUIDANCE_SCALE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.GUIDANCE_SCALE.DESCRIPTION,
      },
      randomize_seed: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.RANDOMIZE_SEED.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.RANDOMIZE_SEED.DESCRIPTION,
      },
      octree_resolution: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.OCTREE_RESOLUTION.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.OCTREE_RESOLUTION.DESCRIPTION,
      },
      remove_background: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.REMOVE_BACKGROUND.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.REMOVE_BACKGROUND.DESCRIPTION,
      },
      num_chunks: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.NUM_CHUNKS.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.NUM_CHUNKS.DESCRIPTION,
      },
      target_face_num: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.TARGET_FACE_NUM.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.TARGET_FACE_NUM.DESCRIPTION,
      },
    },
    dalle3: {},
    any_llm: {
      model: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.ANY_LLM.MODEL.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.ANY_LLM.MODEL.DESCRIPTION,
      },
      temperature: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.ANY_LLM.TEMPERATURE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.ANY_LLM.TEMPERATURE.DESCRIPTION,
      },
      thinking: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.ANY_LLM.THINKING.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.ANY_LLM.THINKING.DESCRIPTION,
      },
    },
    prompt_enhancer: {
      model: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.ANY_LLM.MODEL.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.ANY_LLM.MODEL.DESCRIPTION,
      },
      system_prompt: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.PROMPT_ENHANCER.SYSTEM_PROMPT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.PROMPT_ENHANCER.SYSTEM_PROMPT.DESCRIPTION,
      },
    },
    image_describer: {
      model: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.ANY_LLM.MODEL.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.ANY_LLM.MODEL.DESCRIPTION,
      },
      prompt: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.IMAGE_DESCRIBER.PROMPT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.IMAGE_DESCRIBER.PROMPT.DESCRIPTION,
      },
    },
    meshy: {
      surface_mode: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.MESHY.SURFACE_MODE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.MESHY.SURFACE_MODE.DESCRIPTION,
      },
    },
    flux11_pro: {
      aspect_ratio: {
        titleKey: PARAMETER_TRANSLATION_KEYS.SHARED.ASPECT_RATIO.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.ASPECT_RATIO.DESCRIPTION,
      },
      width: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.WIDTH.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.WIDTH.DESCRIPTION,
      },
      height: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.HEIGHT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.HEIGHT.DESCRIPTION,
      },
      safety_tolerance: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.SAFETY_TOLERANCE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.SAFETY_TOLERANCE.DESCRIPTION,
      },
      prompt_upsampling: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.PROMPT_UPSAMPLING.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.PROMPT_UPSAMPLING.DESCRIPTION,
      },
      output_format: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.OUTPUT_FORMAT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.OUTPUT_FORMAT.DESCRIPTION,
      },
      output_quality: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.OUTPUT_QUALITY.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.OUTPUT_QUALITY.DESCRIPTION,
      },
    },
    flux11_pro_ultra: {
      image_prompt_strength: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.IMAGE_PROMPT_STRENGTH.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.IMAGE_PROMPT_STRENGTH.DESCRIPTION,
      },
      aspect_ratio: {
        titleKey: PARAMETER_TRANSLATION_KEYS.SHARED.ASPECT_RATIO.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.ASPECT_RATIO.DESCRIPTION,
      },
      safety_tolerance: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.SAFETY_TOLERANCE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.SAFETY_TOLERANCE.DESCRIPTION,
      },
      raw: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.RAW.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.RAW.DESCRIPTION,
      },
      output_format: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.OUTPUT_FORMAT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.OUTPUT_FORMAT.DESCRIPTION,
      },
    },
    flux_kontext: {
      model: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.MODEL.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.MODEL.DESCRIPTION,
      },
      aspect_ratio: {
        titleKey: PARAMETER_TRANSLATION_KEYS.SHARED.ASPECT_RATIO.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.ASPECT_RATIO.DESCRIPTION,
      },
      num_inference_steps: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.NUM_INFERENCE_STEPS.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.NUM_INFERENCE_STEPS.DESCRIPTION,
      },
      guidance_scale: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.GUIDANCE_SCALE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.GUIDANCE_SCALE.DESCRIPTION,
      },
      output_format: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.OUTPUT_FORMAT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.OUTPUT_FORMAT.DESCRIPTION,
      },
    },
    flux_kontext_multi_image: {
      aspect_ratio: {
        titleKey: PARAMETER_TRANSLATION_KEYS.SHARED.ASPECT_RATIO.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT_MULTI_IMAGE.ASPECT_RATIO.DESCRIPTION,
      },
      output_format: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT_MULTI_IMAGE.OUTPUT_FORMAT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT_MULTI_IMAGE.OUTPUT_FORMAT.DESCRIPTION,
      },
    },
    topaz_image_sharpen: {
      model: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.MODEL.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.MODEL.DESCRIPTION,
      },
      output_format: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.OUTPUT_FORMAT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.OUTPUT_FORMAT.DESCRIPTION,
      },
      subject_detection: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.SUBJECT_DETECTION.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.SUBJECT_DETECTION.DESCRIPTION,
      },
      face_enhancement: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.FACE_ENHANCEMENT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.FACE_ENHANCEMENT.DESCRIPTION,
      },
      face_enhancement_creativity: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.FACE_ENHANCEMENT_CREATIVITY.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.FACE_ENHANCEMENT_CREATIVITY.DESCRIPTION,
      },
      face_enhancement_strength: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.FACE_ENHANCEMENT_STRENGTH.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.FACE_ENHANCEMENT_STRENGTH.DESCRIPTION,
      },
    },
    topaz_image_upscale: {
      model: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.MODEL.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.MODEL.DESCRIPTION,
      },
      upscale_factor: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.UPSCALE_FACTOR.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.UPSCALE_FACTOR.DESCRIPTION,
      },
      crop_to_fill: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.CROP_TO_FILL.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.CROP_TO_FILL.DESCRIPTION,
      },
      face_enhancement: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.FACE_ENHANCEMENT.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.FACE_ENHANCEMENT.DESCRIPTION,
      },
      subject_detection: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.SUBJECT_DETECTION.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.SUBJECT_DETECTION.DESCRIPTION,
      },
      face_enhancement_strength: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.FACE_ENHANCEMENT_STRENGTH.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.FACE_ENHANCEMENT_STRENGTH.DESCRIPTION,
      },
      face_enhancement_creativity: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.FACE_ENHANCEMENT_CREATIVITY.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.FACE_ENHANCEMENT_CREATIVITY.DESCRIPTION,
      },
    },
    kling: {
      model: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.KLING.MODEL.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.KLING.MODEL.DESCRIPTION,
      },
      duration: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.KLING.DURATION.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.KLING.DURATION.DESCRIPTION,
      },
      cfg_scale: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.KLING.CFG_SCALE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.KLING.CFG_SCALE.DESCRIPTION,
      },
      shot_type: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.KLING.SHOT_TYPE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.KLING.SHOT_TYPE.DESCRIPTION,
      },
      aspect_ratio: {
        titleKey: PARAMETER_TRANSLATION_KEYS.SHARED.ASPECT_RATIO.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.KLING.ASPECT_RATIO.DESCRIPTION,
      },
      generate_audio: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.KLING.GENERATE_AUDIO.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.KLING.GENERATE_AUDIO.DESCRIPTION,
      },
    },
    eleven_labs_voice_changer: {
      seed: {
        titleKey: PARAMETER_TRANSLATION_KEYS.SHARED.SEED.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.SHARED.SEED.DESCRIPTION,
      },
      voice: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.ELEVEN_LABS_VOICE_CHANGER.VOICE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.ELEVEN_LABS_VOICE_CHANGER.VOICE.DESCRIPTION,
      },
      remove_background_noise: {
        titleKey: PARAMETER_TRANSLATION_KEYS.MODELS.ELEVEN_LABS_VOICE_CHANGER.REMOVE_BACKGROUND_NOISE.TITLE,
        descriptionKey: PARAMETER_TRANSLATION_KEYS.MODELS.ELEVEN_LABS_VOICE_CHANGER.REMOVE_BACKGROUND_NOISE.DESCRIPTION,
      },
    },
  },
  muxv2: {
    options: {
      titleKey: PARAMETER_TRANSLATION_KEYS.MUXV2.OPTIONS.TITLE,
      descriptionKey: PARAMETER_TRANSLATION_KEYS.MUXV2.OPTIONS.DESCRIPTION,
    },
  },
  masks: {
    feather: {
      titleKey: PARAMETER_TRANSLATION_KEYS.MASKS.FEATHER.TITLE,
      descriptionKey: PARAMETER_TRANSLATION_KEYS.MASKS.FEATHER.DESCRIPTION,
    },
    matte_choker: {
      titleKey: PARAMETER_TRANSLATION_KEYS.MASKS.MATTE_CHOKER.TITLE,
      descriptionKey: PARAMETER_TRANSLATION_KEYS.MASKS.MATTE_CHOKER.DESCRIPTION,
    },
    invert: {
      titleKey: PARAMETER_TRANSLATION_KEYS.MASKS.INVERT.TITLE,
      descriptionKey: PARAMETER_TRANSLATION_KEYS.MASKS.INVERT.DESCRIPTION,
    },
  },
  shared: {
    seed: {
      titleKey: PARAMETER_TRANSLATION_KEYS.SHARED.SEED.TITLE,
      descriptionKey: PARAMETER_TRANSLATION_KEYS.SHARED.SEED.DESCRIPTION,
    },
  },
};
